export default "__VITE_ASSET__CLe_WXLT__"